import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import SENSORS from '@/constants/sensor';
import Styles from './index.module.scss';

const logo = 'https://spcn-webfront.skypixel.com/entertainment/public/h5/assets/images/logo.179e4d48.png';

const PageTopbar = ({ className, onSensorTrack, onRedirect }) => {
  const handleDownload = () => {
    onSensorTrack(SENSORS.LIGHT_H5_DOWNLOAD_BUTTON_CLICK);
    onRedirect();
  };

  return (
    <div className={cx(Styles.root, className)}>
      <div className={Styles.left}>
        <div className={Styles.logo} style={{ backgroundImage: `url(${logo})` }} alt="Logo" />
        <div className={Styles.content}>
          <div className={Styles.title}>畅片App</div>
          <div className={Styles.subtitle}>畅快剪辑 即刻出片</div>
        </div>
      </div>
      <div className={Styles.right} onClick={handleDownload} aria-hidden>
        下载畅片
      </div>
    </div>
  );
};

PageTopbar.propTypes = {
  className: PropTypes.string,
  onSensorTrack: PropTypes.func,
  onRedirect: PropTypes.func,
};

PageTopbar.defaultProps = {
  className: '',
  onSensorTrack: () => true,
  onRedirect: () => true,
};

export default PageTopbar;
